import styled from "@mui/material/styles/styled"
import Card from "@mui/material/Card"
import { CardOwnProps } from "@mui/material/Card"

interface AuthCardProps extends CardOwnProps {
  card?: "show" | undefined
}

export const AuthCard = styled(Card)<AuthCardProps>(
  ({ theme, card }) => `
    padding: 24px;
    background-color: ${theme.palette.background.paper};
    width: 100%;
  ${
    card !== "show"
      ? `
  ${theme.breakpoints.down("sm")}{
    background-color: ${theme.palette.background.default} ;
    box-shadow: none;
    padding: 0px;
  }
  `
      : ""
  }

  ${theme.breakpoints.up("sm")}{
    margin-left: auto;
    margin-right: auto;
    width: 600px ; 
  }
 
  `
)
